<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/25/20
-->

<template>
	<FormElementTemplate
		:formElement="formElement"
		:viewMode="viewMode"
		v-bind="$attrs">

		<template #body>
			<div class="mt-2 mb-3 qw-row disableClick" @click="onClickHandler">
				<AddressView
					class="qw-col flex-grow-1"
					:readonly="!isAnswerMode"
					:borderDotted="!isAnswerMode"
					v-model="formElement.answer"/>

				<ToolTipView v-if="isEditMode">
					This is a preview of what your client will see.
				</ToolTipView>
			</div>


		</template>

	</FormElementTemplate>
</template>

<script>

import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseFormElement from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTemplate from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTemplate.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import FormElementAddress from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/FormElementAddress";
import AddressView from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/ClientDetails/AddressView.vue";

export default {
	name: "FormElementAddressView",
	components: {AddressView, ToolTipView, FormElementTemplate},
	extends: BaseFormElement,
	props: {
		formElement: {FormElementAddress, required: true}
	},

	data() {
		return {
			address: null
		}
	},


	methods: {
		onAddressChanged(address){

		},
		onClickHandler(event) {
			if (!this.isEditable || !this.isAnswerMode) {
				event.preventDefault()
			}
		}
	},

	computed: {
		answerPlaceholder() {
			// if (this.isViewMode) {
			// 	return "Your answer"
			// }
			// switch (this.formElement.type) {
			// 	case FormElementType.MULTILINE:
			// 		return "Answer text"
			// }
			// return "Short answer text"
			if (this.isAnswerMode) {
				return "Your answer"
			}
			if (this.isViewMode) {
				return "No answer provided"
			}
			return "Client's answer"
		},

		isMultiline() {
			return this.formElement.type === FormElementType.MULTILINE
		}

	}

}
</script>

<style>

</style>
